import { IComponentOptions, IController } from 'angular';
import { BuyStylesPopoverController } from './buy-styles-popover';
import template from './buy-search-button.html';

export class BuySearchButtonController implements IController {
    protected popoverController?: BuyStylesPopoverController;

    static $inject = ['$element'];
    constructor(protected $element: JQLite) {
        this.$element.addClass('button');
        this.$element.on('click', () => {
            if (!this.popoverController) {
                console.error(
                    'BuySearchButtonController.on("click"),  popoverController not set, not showing popover.'
                );
                return;
            }
            this.popoverController.show();
            this.popoverController.goToState('add-styles-from-cart');
        });
    }
}


export const BuySearchButtonComponent: IComponentOptions = {
    controller: BuySearchButtonController,
    template,
};
